import { Phone } from "lucide-react";
import { BRAND, FEATURED } from "../data/restaurant";
import { Reveal, Stagger, StaggerItem } from "./motion/Reveal";
import { BrushUnderline } from "./BrushHeading";

export default function FeaturedDishes() {
  return (
    <section data-testid="featured-section" className="relative py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <Reveal className="flex flex-col gap-4 text-center sm:text-left">
          <h2 className="font-display text-3xl font-black uppercase leading-[1.05] tracking-tight text-jet sm:text-5xl">
            Signature <BrushUnderline>dishes</BrushUnderline>
          </h2>
          <p className="text-base font-medium text-jet/80">
            Straight from our promo board — the plates everyone talks about.
          </p>
        </Reveal>

        <Stagger className="mt-12 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {FEATURED.map((dish, i) => (
            <StaggerItem key={dish.name}>
              <figure
                data-testid="featured-dish-card"
                className={`group h-full rounded-3xl border-[3px] border-jet bg-cream p-3 shadow-hard transition-all duration-300 hover:-translate-y-2 hover:rotate-0 hover:shadow-hard-lg ${
                  i % 2 === 0 ? "lg:-rotate-2" : "lg:rotate-2"
                } ${i === 0 ? "sm:col-span-2 lg:col-span-1" : ""}`}
              >
                <div className="overflow-hidden rounded-2xl border-2 border-jet">
                  <img
                    src={dish.img}
                    alt={`${dish.name} — ${dish.price} promotional poster`}
                    className="aspect-square w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
                    loading="lazy"
                  />
                </div>
                <figcaption className="flex items-center justify-between gap-3 px-2 py-3">
                  <span className="font-display text-base font-extrabold uppercase leading-tight text-jet">{dish.name}</span>
                  <span className="shrink-0 font-display text-lg font-black text-crimson">{dish.price}</span>
                </figcaption>
              </figure>
            </StaggerItem>
          ))}
        </Stagger>

        <Reveal className="mt-12 flex justify-center">
          <a
            href={BRAND.phoneHref}
            data-testid="featured-call-cta"
            className="inline-flex items-center gap-2 rounded-full border-[3px] border-jet bg-jet px-8 py-4 font-display text-base font-extrabold uppercase text-cream shadow-hard-flame transition-all duration-200 hover:-translate-y-1 hover:shadow-[10px_10px_0_0_#D92124]"
          >
            <Phone className="h-5 w-5" aria-hidden="true" />
            Order these by phone
          </a>
        </Reveal>
      </div>
    </section>
  );
}
